import storage from 'localforage'
import join from 'url-join'

import { createAction, history, asyncAction } from '../util/index.js'
import { setGlobalHeader } from '../util/http'
import { hasAuthCheckStarted } from './reducer.js'
import { getAppStatus } from '../appStatus/actions'
import { isOffline } from '../offline/reducer.js'
import * as oAuth from '../auth/oAuth.js'
import { http } from '../util'
import config from '../config'

let locationKey = 'location'
let routeStore = storage.createInstance({ name: 'route-store ' })

export const startAuthCheck = createAction('AUTH_CHECK_START', { noPayload: true })
export const finishAuthCheck = createAction('AUTH_CHECK_COMPLETE', { noPayload: true })
export const setAuthCheckError = createAction('AUTH_CHECK_ERROR')
export const setADandJiraUser = createAction('SET_AD_AND_JIRA_USER')

export const setUserLogin = createAction('LOGIN_SET_USER')

const api = join.bind(null, config.apiUrl)

export const getExtraUserInfo = asyncAction({
  baseName: 'EXTRA_USER_INFO_GET',
  action: action => (userEmail) => (dispatch, getState) => {
    let adUserInfo = getState().auth.get('adUserInfo')
    if ( adUserInfo === undefined || adUserInfo == null) {
      dispatch(action.start())
      return http.get(api(`/ssp/user?id=${userEmail}`))
      .then(userInfo => {
        dispatch(action.success(userInfo))
      })
      .catch(err => {
        console.error('error getting AD and JIRA user info api response', err)
        dispatch(action.error(err))
      })
    } else {
      return Promise.resolve()
    }
  }
})

export const loginUser = () => (dispatch, getState) => {
  let route = getState().routing.location.pathname
  return routeStore.setItem(locationKey, route)
    .then(() => oAuth.login())
}

export const logoutUser = (skipRedirect) => (dispatch, getState) => {
  return oAuth.logout()
    .then(() => routeStore.removeItem(locationKey))
    .then(() => {
      dispatch(setUserLogin(null))
      if (!skipRedirect) history.push('/')
    })
    .catch(error => {
      // TODO: NOTIFY THE USER: this is an app decision. Use a toast, error page, etc
      console.error(error)
    })
}

export const initializeUserAuth = () => (dispatch, getState) => {
  let state = getState()
  if (hasAuthCheckStarted(state)) return Promise.resolve()
  
  dispatch(startAuthCheck())
  return oAuth.checkForToken()
    .then(loginToken => {
      if (!loginToken) {
        if (isOffline(state)) {
          dispatch(finishAuthCheck())
          return
        }
        loginUser()(dispatch, getState)
        // Don't finish auth check if we are logging user in
        return
      }
      
  

      setGlobalHeader('Authorization', 'Bearer ' + loginToken.accessToken)
      watchForTokenExpiration(dispatch, loginToken)
      // TODO: Configure your HTTP client to use the token here      
      dispatch(setUserLogin(loginToken))
      return routeStore.getItem(locationKey)
        .then(previousRoute => {
          if (previousRoute) {
            history.replace(previousRoute)
            return routeStore.removeItem(locationKey)
          }          
        })
        .then(dispatch(getExtraUserInfo(loginToken.email)))
        .then(dispatch(finishAuthCheck()))
        .then(dispatch(getAppStatus()))
    })
    .catch(err => {
      dispatch(setAuthCheckError(err))
    })
    
}

let tokenExpirationWatcher = null
function watchForTokenExpiration (dispatch, token) {
  if (tokenExpirationWatcher) {
    clearInterval(tokenExpirationWatcher)
  }

  tokenExpirationWatcher = setInterval(() => {
    if (token.isExpired) {
      clearInterval(tokenExpirationWatcher)
      tokenExpirationWatcher = null
      logoutUser(true)(dispatch)
    }
  }, 1000)
}



// WEBPACK FOOTER //
// ./client/src/auth/actions.js